var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagSahrawiArabDemocraticRepublic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_16350)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.58763 9.04341C0.5705 11.1469 0 13.5067 0 15.9999C0 18.4931 0.5705 20.8529 1.58763 22.9564L16 24.3477L30.4124 22.9564C31.4295 20.8529 32 18.4931 32 15.9999C32 13.5067 31.4295 11.1469 30.4124 9.04341L16 7.6521L1.58763 9.04341Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.58789 22.9565C4.17577 28.3085 9.65639 32 15.9997 32C22.343 32 27.8236 28.3085 30.4115 22.9565H1.58789Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.58789 9.0435H30.4115C27.8236 3.69156 22.3431 0 15.9997 0C9.65633 0 4.17577 3.69156 1.58789 9.0435Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.68622 4.68628C-1.56215 10.9347 -1.56215 21.0653 4.68622 27.3138C7.26828 24.7317 9.75159 22.2484 16 16L4.68622 4.68628Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1739 15.9999C20.1739 13.6688 21.8122 11.7214 24 11.2436C23.6637 11.1702 23.3149 11.1304 22.9565 11.1304C20.267 11.1304 18.0869 13.3105 18.0869 15.9999C18.0869 18.6894 20.267 20.8695 22.9565 20.8695C23.3148 20.8695 23.6637 20.8297 24 20.7562C21.8122 20.2785 20.1739 18.3311 20.1739 15.9999Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.205 12.8696L24.8958 14.9955H27.1309L25.3226 16.3091L26.0134 18.4349L24.205 17.1211L22.3968 18.4349L23.0876 16.3091L21.2792 14.9955H23.5143L24.205 12.8696Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_16350"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagSahrawiArabDemocraticRepublic);
export default __webpack_public_path__ + "static/media/flag_sahrawi_arab_democratic_republic.24a1f83009d951fc56cbe0a9167f5cf1.svg";
export { ForwardRef as ReactComponent };